import { useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "../axios.jsx";
import validator from "validator";
import Cookies from "js-cookie";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

function ForgotPassword() {
  const [mobile, setMobile] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordSuccess, setPasswordSuccess] = useState("");
  const [loginError, setLoginError] = useState("");
  const [passwordValid, setPasswordValid] = useState("");
  const [password, setPassword] = useState("");
  const [security, setSecurity] = useState("");
  const [btnDisabeled, setBtnDisabled] = useState(true);
  const checkPassword = (e) => {
    if (
      validator.isStrongPassword(e, {
        minLength: 8,
        minLowercase: 1,
        minUppercase: 1,
        minNumbers: 1,
        minSymbols: 1,
      })
    ) {
      setPasswordValid("");
      setPasswordSuccess("Is Strong Password");
    } else {
      setPasswordValid("Is Not Strong Password");
    }
  };
  const validatePasswords = (e) => {
    if (password === e.target.value) {
      setPasswordError("");
      setBtnDisabled(false);
    } else {
      setBtnDisabled(true);
      setPasswordError("Passwords does not match");
    }
  };
  const loc = useLocation();
  const handleForgotSubmit = async (e) => {
    e.preventDefault();
    if(passwordValid===""){
    var reqData = {
      mobile: loc.state.mobile,
      password: password,
      security: security,
    };
    try {
      const resData = await axios.post("/api/forgot-password", reqData);
      if (resData.status === 200) {
        alert("Password Change Successfull");
        logout();
      }
    } catch (e) {
      setLoginError("Invalid Mobile Number or Security Answer");
    }}
    else{
      setLoginError("Invalid new password")
    }
  };

  return (
    <div className="Auth-form-container">
      <form onSubmit={handleForgotSubmit} className="Auth-form">
        <div className="Auth-form-content">
          <h3 className="Auth-form-title">Scholar Update Password</h3>
          <div className="form-group mt-3">
            <label>
              Security Question:
              <br />
              Who is your Childhood Friend?
            </label>
            <input
              type="text"
              value={security}
              onChange={(e) => setSecurity(e.target.value)}
              className="form-control mt-1"
              placeholder="Enter Answer"
              required
            />
          </div>
          <div className="form-group mt-3">
            <label>New Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                checkPassword(e.target.value);
              }}
              className="form-control mt-1"
              placeholder="Password"
              required
            />
            <small>
              <span className="text-danger">{passwordValid}</span>
              <span className="text-success">{passwordSuccess}</span>
            </small>
          </div>
          <div className="form-group mt-3">
            <label>Confirm Password</label>
            <input
              type="password"
              onChange={validatePasswords}
              className="form-control mt-1"
              placeholder="Enter password again"
              required
            />
            <span className="text-danger">{passwordError}</span>
          </div>
          <div className="d-grid gap-2 mt-3">
            <button
              type="submit"
              className="btn btn-secondary"
              disabled={btnDisabeled}
            >
              Submit
            </button>
          </div>
          <span className="text-danger justify-content-center">
            {loginError}
          </span>
          <br></br>
          <br></br>
        </div>
      </form>
    </div>
  );
}

export default ForgotPassword;

function logout() {
  window.localStorage.clear();
  Cookies.remove("userInfo");
  Cookies.remove("username");
  window.location.href = "/";
}
